import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function imageExtensionValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file: File | null = control.value;

    if (file) {
      const fileName = file.name;
      const fileExtension = fileName?.split('.')?.pop()?.toLowerCase();

      if (fileExtension && !['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(fileExtension)) {
        return { invalidExtension: 'The image must be in jpg, jpeg, png, gif or webp format' };
      }
    }

    return null;
  };
}
